"use strict";
/*
 * Created on 2019-07-15
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author JMr
 */


var CompetitorPriceChangeReportDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompetitorPriceChangeReportDTOConverter, _DataObjectConverter_);

  function CompetitorPriceChangeReportDTOConverter() {
    _classCallCheck(this, CompetitorPriceChangeReportDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceChangeReportDTOConverter).apply(this, arguments));
  }

  return CompetitorPriceChangeReportDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompetitorPriceChangeReportDTOConverter = CompetitorPriceChangeReportDTOConverter;